<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-x
    left
    max-width="400px"
    min-width="200px"
    :disabled="readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <c-text-field
        v-model="euDate"
        :class="requiredB ? 'required' : ( dottedB ? 'dotted' : '')"
        :rules="rulesCombined"
        :label="label"
        :readonly="readonly"
        @keydown="menu = false"
        @blur="onFieldInput"
        @click="menu = menu || openOnClick"
        clearable
        @click:clear="clearDate"
      >
        <template v-slot:append v-if="!readonly">
          <v-btn v-bind="attrs" v-on="on" icon><v-icon>mdi-calendar</v-icon></v-btn>
        </template>
      </c-text-field>
                      
    </template>
    <v-date-picker
      v-model="editDate"
      full-width
      @input="onPickerInput"
      @change="menu = false"
      :min="min"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
// @ is an alias to /src
import { convertToIso, parseToDateString } from '@/services/DatetimeUtils.js';
export default {
  name: 'DatePicker',
  props: {
    value: String,
    label: String,
      // date: String,
    readonly: {
        type: Boolean,
        default: false
    },
    required:{
      type: Boolean,
      default: false
    },
    dotted:{
      type: Boolean,
      default: false
    },
    clearable:{
      type: Boolean,
      default: false
    },
    openOnClick: Boolean,
    min: String,
    rules: Array
  },
  components: {
  },
  mounted () {
    this.editDate = this.value ? this.value.substring(0, 10) : null;
    this.setEuDate();
  },
  data () {
    return {
      menu: null,
      editDate: null,
      euDate: null
    }
  },
  methods: {
    onPickerInput () {
      this.$emit('input', this.editDate);
      this.setEuDate();
    },
    onFieldInput () {
      this.setEditDate();
      this.$emit('input', this.editDate);
    },
    setEuDate () {
      this.euDate = parseToDateString(this.editDate);
    },
    setEditDate () {
      this.editDate = convertToIso(this.euDate);
    },
    clearDate() {
      this.editDate = null
      this.euDate = null
      this.$emit('input', null)
    }
  },
  watch: {
    value: {
      handler () {
        this.editDate = this.value ? this.value.substring(0, 10) : null;
        this.setEuDate();
      }
    }
  },
  computed: {
    parsedDate () {
      return parseToDateString(this.editDate);
    },
    requiredB(){
      return this.required ? true : false;
    },
    dottedB(){
      return this.dotted ? true : false;
    },
    clearableB(){
      return this.clearable ? true : false;
    },
    rulesCombined () {
      var rulesCombined = this.requiredB ? [this.$common.rules.required] : [];
      if (this.rules){
        rulesCombined.push(...this.rules);
      }
      return rulesCombined;
    }
  }
}
</script>

<style scoped>
.required >>> fieldset {
  border-left: 3px solid dodgerblue;
}
.dotted >>> fieldset {
  border-left: 3px dotted dodgerblue;
}
</style>